"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _nuiIntlRuntime = _interopRequireWildcard(require("@concur/nui-intl-runtime"));
var _reactHelmet = require("react-helmet");
var _client = _interopRequireDefault(require("@concur/nui-config/lib/client"));
var _reactUiTheming = require("@concur/react-ui-theming");
var _LayoutGrid = _interopRequireDefault(require("@concur/nui-layouts/LayoutGrid"));
var _reactRouterDom = require("react-router-dom");
var _Analytics = _interopRequireDefault(require("./Analytics"));
var _config = _interopRequireDefault(require("../config"));
var _analytics = require("../util/analytics");
var _constants = require("../constants");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /* eslint-disable no-new-func */
function NuiPage(props) {
  var contentHeader = props.contentHeader,
    baseUrl = props.baseUrl,
    nuiPage = props.nuiPage,
    _props$nuiPage = props.nuiPage,
    _props$nuiPage2 = _props$nuiPage === void 0 ? {} : _props$nuiPage,
    _props$nuiPage2$brand = _props$nuiPage2.brandingId,
    brandingId = _props$nuiPage2$brand === void 0 ? _config.default.nui.default_brandingId : _props$nuiPage2$brand,
    theme = _props$nuiPage2.theme,
    is16ColsEnabled = _props$nuiPage2.is16ColsEnabled,
    isFullyResponsive = _props$nuiPage2.isFullyResponsive,
    isFluid = _props$nuiPage2.isFluid,
    serverContentDensity = _props$nuiPage2.contentDensity,
    getAppDimensionsForAnalytics = props.getAppDimensionsForAnalytics,
    getCoreDataForAnalytics = props.getCoreDataForAnalytics,
    _props$userPrefs = props.userPrefs,
    _props$userPrefs2 = _props$userPrefs === void 0 ? {} : _props$userPrefs,
    isLoggedIn = _props$userPrefs2.isLoggedIn,
    fetchNuiPageData = props.fetchNuiPageData,
    _props$disableDefault = props.disableDefaultLayout,
    disableDefaultLayout = _props$disableDefault === void 0 ? false : _props$disableDefault;

  // Fetch nuiPage data if it does not exist
  (0, _react.useEffect)(function () {
    if (isLoggedIn && !nuiPage) {
      fetchNuiPageData();
    }
  }, []);
  var localeData = (0, _nuiIntlRuntime.getLocaleData)(props);
  var signinData = {};
  try {
    signinData = window.NUI_TRANSLATIONS;
  } catch (error) {
    try {
      signinData = window.NUI_TRANSLATIONS;
      console.warn("Translation file for language ".concat(localeData.lang, " not found in @concur/nui-auth/translations/. Using ").concat(_constants.DEFAULT_LANGUAGE, " translations. Try updating the @concur/nui-auth package."));
    } catch (error) {
      console.warn("Translation file for language ".concat(localeData.lang, " and default ").concat(_constants.DEFAULT_LANGUAGE, " translations not found in @concur/nui-auth/translations/. Try updating the @concur/nui-auth package."));
    }
  }

  // Pass messages through from parent NuiIntlProvider, if we are nested
  var outerMessages = {};

  // Check if nested in another NuiIntlProvider
  if ((0, _react.useContext)(_nuiIntlRuntime.IntlContext)) {
    var _useIntl;
    outerMessages = ((_useIntl = (0, _nuiIntlRuntime.useIntl)()) === null || _useIntl === void 0 || (_useIntl = _useIntl.preferences) === null || _useIntl === void 0 ? void 0 : _useIntl.messages) || {};
  }
  var intlData = _objectSpread(_objectSpread({}, outerMessages), signinData);

  // Parse client side or server side config
  var clientConfig = (0, _client.default)();

  // Use client side config if it exists
  var config = Object.keys(clientConfig).length > 0 ? clientConfig : _config.default;
  var clientContentDensity = config.nui.content_density;
  var useCompactStyles = clientContentDensity === 'compact' || serverContentDensity === 'compact';
  var bodyClassNames = (0, _classnames.default)("cnqr-theme-".concat(brandingId), {
    'cnqr-body-overflow-visible': !is16ColsEnabled && !isFullyResponsive,
    'nui-widgets-density-compact': useCompactStyles
  });
  var content = disableDefaultLayout ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Outlet, null), props.children) : /*#__PURE__*/_react.default.createElement(_LayoutGrid.default, {
    id: "cnqr-app-content",
    className: "cnqr-app-content",
    fluid: isFluid,
    fullyResponsive: isFullyResponsive,
    role: "main",
    use16Cols: is16ColsEnabled
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Outlet, null), props.children);
  return /*#__PURE__*/_react.default.createElement(_reactUiTheming.ThemeProvider, {
    theme: theme,
    density: serverContentDensity || clientContentDensity
  }, /*#__PURE__*/_react.default.createElement(_nuiIntlRuntime.default, {
    messages: intlData,
    localeData: localeData
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "react-component-wrapper"
  }, /*#__PURE__*/_react.default.createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react.default.createElement("body", {
    id: "cnqrBody",
    className: bodyClassNames
  })), /*#__PURE__*/_react.default.createElement("span", {
    id: "nullSpan",
    tabIndex: -1
  }), contentHeader, content, /*#__PURE__*/_react.default.createElement(_Analytics.default, {
    baseUrl: baseUrl,
    getAppDimensionsForAnalytics: getAppDimensionsForAnalytics,
    getCoreDataForAnalytics: getCoreDataForAnalytics,
    analyticsParams: (0, _analytics.getAnalyticsParamsForDataCenter)(config)
  }))));
}
NuiPage.propTypes = {
  baseUrl: _propTypes.default.string,
  children: _propTypes.default.any,
  contentHeader: _propTypes.default.any,
  fetchNuiPageData: _propTypes.default.func,
  isLoggedIn: _propTypes.default.bool,
  nuiPage: _propTypes.default.any,
  getAppDimensionsForAnalytics: _propTypes.default.func,
  disableDefaultLayout: _propTypes.default.bool
};
var _default = exports.default = NuiPage;